import React, { useContext } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { accepted } from '@mummssoftware/utils/hope';
import { Button } from '@material-ui/core';
import { HopeContext } from '../Context/HopeWidgetContext';
import { SET_BATCH_MODE } from '../Context/constants';
import { StyledBatchButton } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

export const BatchAcceptButton = () => {
  const {
    palette: { primary },
  } = useTheme() as any;
  const {
    dispatch,
    batchMode,
    batchHopeActionUpdate,
    selectedRows,
    showLoader,
  } = useContext(HopeContext);
  const isBatchAccept = batchMode === accepted;

  const showButton = !batchMode || isBatchAccept;
  const enabled = showLoader ? false : !isBatchAccept || !!selectedRows?.length;

  // styles defined here to override MUI css
  return (
    <>
      {showButton && (
        <StyledBatchButton
          style={{
            color: primary.contrastText,
            backgroundColor: enabled ? primary.main : 'grey',
            fontSize: '10px',
            height: '1.25em',
            fontWeight: 'bold',
            padding: '10px',
            margin: '5px',
          }}
          onClick={() => {
            if (isBatchAccept) {
              selectedRows &&
                selectedRows?.length > 0 &&
                batchHopeActionUpdate(selectedRows, accepted);
            } else {
              dispatch({ type: SET_BATCH_MODE, payload: accepted });
            }
          }}
        >
          {batchMode ? 'Accept' : `${defaults.batchAccept}`}
        </StyledBatchButton>
      )}
    </>
  );
};
